import { ServerImageInfo } from '@/api/type-server'
import { PortProtocol } from '@/consts/machine'

export class Image {
  id = 0
  resID = ''
  alias = ''
  description = ''
  ports: ServerImageInfo['ports']

  constructor(props: ServerImageInfo) {
    this.id = props.id
    this.resID = props.resID
    this.alias = props.alias
    this.description = props.description
    this.ports = props.ports || []
  }

  get supportVnc(): boolean {
    return this.ports.findIndex((p) => p.protocol === PortProtocol.VNC) >= 0
  }
}
